export interface AssistantTraceStep {
  id: string;
  label: string;
  details?: string[];
  state?: 'run' | 'done' | 'wait';
}

export function applyLiveStep(
  steps: AssistantTraceStep[],
  incoming: AssistantTraceStep
): AssistantTraceStep[] {
  const next = {
    id: incoming.id,
    label: incoming.label,
    details: incoming.details,
    state: incoming.state
  };
  const index = steps.findIndex((step) => step.id === incoming.id);
  if (index < 0) return [...steps, next];
  const copy = steps.slice();
  copy[index] = { ...copy[index], ...next };
  return copy;
}

export function liveStepIndex(steps: AssistantTraceStep[]): number {
  const running = steps.findIndex((step) => step.state === 'run');
  if (running >= 0) return running;
  return Math.max(0, steps.length - 1);
}

export function planRunTrace(actionId: string): AssistantTraceStep[] {
  if (actionId === 'run_search') {
    return [
      { id: 'build', label: 'Générer les filtres' },
      { id: 'apply', label: 'Appliquer' }
    ];
  }
  if (actionId === 'save_search') {
    return [
      { id: 'build', label: 'Générer les filtres' },
      { id: 'save', label: 'Enregistrer' }
    ];
  }
  if (actionId === 'apply_saved_search') {
    return [
      { id: 'load', label: 'Charger la recherche' },
      { id: 'apply', label: 'Appliquer' }
    ];
  }
  if (actionId === 'create_automation') {
    return [
      { id: 'build', label: 'Monter la règle' },
      { id: 'save', label: 'Activer' }
    ];
  }
  if (actionId === 'create_product' || actionId === 'create_status' || actionId === 'create_client' || actionId === 'create_commission_rule') {
    return [
      { id: 'save', label: 'Enregistrer' },
      { id: 'open', label: 'Ouvrir' }
    ];
  }
  if (actionId === 'create_chart') {
    return [
      { id: 'filter', label: 'Lier la recherche' },
      { id: 'save', label: 'Créer le graphique' }
    ];
  }
  if (actionId === 'apply_chart') {
    return [
      { id: 'load', label: 'Trouver le graphique' },
      { id: 'open', label: 'Ouvrir' }
    ];
  }
  if (actionId === 'pin_search') {
    return [
      { id: 'load', label: 'Trouver la recherche' },
      { id: 'save', label: 'Épingler' }
    ];
  }
  if (actionId === 'adjust_stock') {
    return [
      { id: 'read', label: 'Lire le produit' },
      { id: 'save', label: 'Ajuster' }
    ];
  }
  if (actionId === 'create_order') {
    return [{ id: 'open', label: 'Ouvrir le formulaire' }];
  }
  return [{ id: 'open', label: 'Ouvrir l’écran' }];
}

export function clampTraceIndex(index: number, total: number): number {
  if (total <= 0) return 0;
  return Math.min(Math.max(0, index), total - 1);
}
